import { ref, readonly, computed, reactive, toRefs } from '@vue/composition-api';

export default function useFetchData() {

    const initialState = {
        cargando: false,
        data: null,
        error: null
    }

    const state = reactive({ ...initialState })

    const limpiar = () => {
        Object.assign(state, initialState)
    }
    
    const fetchData = async (opciones) => {
        
        console.log("Haciendo fetch con:", { opciones })

        state.cargando = true

        try {
            const res = await fetch(opciones.url, opciones)
            const respuesta = await res.json()
            
            if (res.ok) {
                state.data = respuesta
                state.error = null
                return
            }

            console.log(res)

            throw { status: res.statusText, ...respuesta }
        }
        catch (e) {
            state.data = null
            state.error = e
        }
        finally {
            state.cargando = false
        }
    }

    return {
        fetchData,
        ...toRefs(state),
        limpiar
    }
}